var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.943,
    height: 20.357,
    viewBox: "0 0 17.943 20.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fill",
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 17.943,
    height: 20.357,
    fill: "#58299c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flame",
    transform: "translate(-6.713 -5.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479",
    transform: "translate(6.713 5.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479-2",
    "data-name": "Group 479",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill",
    id: "Path_726",
    "data-name": "Path 726",
    d: "M17.919,10.089a1.954,1.954,0,0,0-1,1.085c-.382.763-.681,0-.681,0,.225-5.241-2.141-6.2-2.141-6.2C13.643,7.956,11.5,7.788,10.43,5.985S10.825.01,10.825.01c-7.608-.393-8.51,10.822-8.51,10.822-.789,0-1.861-1.916-1.861-1.916C-1.762,16.8,4.76,19.64,6.439,20.232a4.977,4.977,0,0,1-1.912-5.117,5.986,5.986,0,0,1,6.327-4.833S8.5,12.495,9.888,13.431c.5.336,1.791,0,1.6-.441A7.071,7.071,0,0,1,13.039,15.4a4.12,4.12,0,0,1-2.18,4.955c7.876-2.211,7.061-10.269,7.061-10.269",
    transform: "translate(0 0)",
    fill: "#58299c"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.fed20957.svg";
export { ForwardRef as ReactComponent };